import { isFunction } from 'lodash';

import { PractitionerSettlementType } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

import { MedicalServiceSettlementType, MedicalServiceSettlementTypeVisitor } from './settlement.types';

export const createMedicalServiceSettlementTypeVisitor = (
   settlementType: MedicalServiceSettlementType | PractitionerSettlementType
): MedicalServiceSettlementTypeVisitor => (visitor) => {
   // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
   const visit = (type: MedicalServiceSettlementType) => {
      if (isFunction(visitor)) {
         return visitor(type);
      }

      return visitor[`visit${type}`]();
   };

   switch (settlementType) {
      case 'None':
      case 'NONE':
         return visit('None');
      case 'Fixed':
      case 'FIXED':
         return visit('Fixed');
      case 'Proportional':
      case 'PROPORTIONAL':
         return visit('Proportional');
      default:
         return assertUnreachable(settlementType);
   }
};
